"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Accordion Component
 *
 * @param {object} props Properties used for the component
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 * @returns {React.ReactElement} A react element
 */

function Accordion(props) {
  if (!props.rendering.fields) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var titleSize = (0, _lodash.isEmpty)(extractedFields.TitleSize.value) ? 'h2' : extractedFields.TitleSize.value;
  var [item, setItem] = (0, _react.useState)('0');
  var handleItemClick = eventKey => () => {
    setItem(item === eventKey ? null : eventKey);
  };
  var mainBody = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _lodash.isEmpty)(extractedFields.Title.value) && (0, _titleHeadTag.headTagTitle)(extractedFields.Title, undefined, titleSize), !(0, _lodash.isEmpty)(extractedFields.PreviewText.value) && /*#__PURE__*/_react.default.createElement("p", null, (0, _richTextField.parseHTML)(extractedFields.PreviewText)), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse, null, (0, _lodash.map)(extractedFields.Categories, (comp, compKey) => {
    return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Group, {
      key: compKey
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Toggle, {
      eventKey: comp.id,
      open: item === comp.id,
      onClick: handleItemClick(comp.id)
    }, (0, _richTextField.parseHTML)(comp.fields.Heading)), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Collapse.Collapse, {
      eventKey: comp.id
    }, (0, _richTextField.parseHTML)(comp.fields.Content)));
  })));
  if (extractedFields.Elevation.value) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "app-container"
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
      variant: 'basic'
    }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, mainBody)));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
      className: "app-container"
    }, mainBody);
  }
}
var _default = exports.default = Accordion;